// services/productRequestApi.ts
import { API_BASE_URL } from '../config/api'
import { Cookies } from 'react-cookie'

export interface UploadImageResponse {
  id: string
}

export interface ProductRequestData {
  productName: string
  author?: string
  vendor?: string
  publisher?: string
  translator?: string
  fullName?: string
  cellphone?: string
  email?: string
  image?: string // UUID from upload
}

export interface ProductRequestResponse extends ProductRequestData {
  id: string
  isFulfilled: boolean
  createdAt: string
  updatedAt: string
}

/**
 * Upload a single image file
 */
export async function uploadImage(file: File): Promise<string> {
  const formData = new FormData()
  formData.append('inputFile', file)

  // Get auth token from cookies
  const cookies = new Cookies()
  const token = cookies.get('@bookstory-auth-token')
  const accessToken = token?.user?.authToken?.accessToken

  const headers: HeadersInit = {}
  if (accessToken) {
    headers['Authorization'] = `bearer ${accessToken}`
  }

  const response = await fetch(`${API_BASE_URL}/files/single`, {
    method: 'POST',
    headers,
    body: formData,
  })

  if (!response.ok) {
    const error = await response
      .json()
      .catch(() => ({ message: 'آپلود تصویر ناموفق بود' }))
    throw new Error(error.message || 'آپلود تصویر ناموفق بود')
  }

  const data: UploadImageResponse = await response.json()
  return data.id
}

/**
 * Create a product request
 */
export async function createProductRequest(
  data: ProductRequestData,
): Promise<ProductRequestResponse> {
  const response = await fetch(`${API_BASE_URL}/product-requests`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    const error = await response
      .json()
      .catch(() => ({ message: 'ارسال درخواست ناموفق بود' }))
    throw new Error(error.message || 'ارسال درخواست ناموفق بود')
  }

  return response.json()
}

/**
 * Get image URL
 */
export function getImageUrl(imageId: string): string {
  return `${API_BASE_URL}/files/${imageId}`
}
